import { useCallback, useContext, useEffect, useState } from "react";
import ListComponent from "../../../components/list/list";
import { IHeadCell } from "../../../components/list/model";
import pubSub, { EVENTS } from "../../../config/pubSub";
import { AppConfig } from "../../../context/context";
import { ApplicationsContext } from "../applications-context";
import { useService } from "../applications-service";
import { IApplicationListRowModel } from "../applications-model";

const defaultApplication: IApplicationListRowModel = {
  count: 0,
  devTenantApps: [],
};

const headCells: IHeadCell[] = [
  { id: "id", label: "", display: false },
  { id: "checkbox", label: "", display: true },
  { id: "name", label: "application_name", display: true },
  { id: "dateAdded", label: "date_added", display: true },
  { id: "clientId", label: "client_id", display: true },
  { id: "accessKey", label: "api_access_key", display: true },
];

const ApplicationListComponent = ({ statusFilter }: { statusFilter: number }) => {
  const { featureFlags, config } = useContext(AppConfig);
  const {
    setSelectedApp,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    setIsAppListLoading,
    rowsPerPageOptions,
    setSelectedCheckedApps,
    selectedCheckedApps,
    applications,
    setApplications,
  } = useContext(ApplicationsContext);
  const { appService } = useService();
  
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState<string[]>([]);

  const convertUtcSecondsToDate = (utcSeconds: number) => {
    const date = new Date(utcSeconds * 1000);
    return date.toLocaleDateString();
  };

  const formatApplicationData = (rawData: any): IApplicationListRowModel => ({
    devTenantApps: rawData.devTenantApps.map((tenant: any) => ({
      id: tenant.id,
      checkbox: false,
      name: tenant.name,
      dateAdded: convertUtcSecondsToDate(tenant.dateAdded),
      clientId: tenant.clientId,
      accessKey: tenant.accessKey,
    })),
    count: rawData.count,
  });

  const fetchApplications = useCallback(
    async (pageNumber: number, size: number) => {
      try {
        setIsAppListLoading(true);
        const response = await appService.getAllApps(config.tenantId, pageNumber + 1, size);
        if (response?.count > 0 && response?.devTenantApps?.length > 0 || pageNumber === 0) {
          setApplications(formatApplicationData(response));
          setCurrentPage(pageNumber);
        } else {
          const catchupResponse = await appService.getAllApps(config.tenantId, pageNumber + 1, size);
          setApplications(formatApplicationData(catchupResponse));
          setCurrentPage(pageNumber - 1);
        }
        setIsAppListLoading(false);
      } catch (error) {
        setApplications(defaultApplication);
        setIsAppListLoading(false);
      }
    },
    [appService, config.tenantId, setIsAppListLoading, setApplications]
  );

  const updateFetch = useCallback(() => {
    fetchApplications(page, rowsPerPage);
  }, [fetchApplications, page, rowsPerPage]);

  useEffect(() => {
    setApplications(defaultApplication);
    updateFetch();
  }, [updateFetch, setApplications]);

 /* useEffect(() => {
    const unsubscribe = pubSub.subscribe(EVENTS.ORGANIZATIONS_LIST, updateFetch);
    return () => unsubscribe();
  }, [updateFetch]);*/

    useEffect(() => {
    const unsubscribe = pubSub.subscribe(EVENTS.ORGANIZATIONS_LIST, () => {
      updateFetch();
    });
    return unsubscribe;
  }, [updateFetch]);

  useEffect(() => {
    if (selectedCheckedApps.length === 0) {
      setSelectedRows([]);
    }
  }, [selectedCheckedApps]);

  const handleSelectionChange = (selectedIds: string[]) => {
    setSelectedCheckedApps(selectedIds);
    setSelectedApp(selectedIds.length === 1 ? selectedIds[0] : null);
  };

  return (
    <>
      <ListComponent
        sortable={!featureFlags?.disableTableSort}
        rows={applications ? applications.devTenantApps : []}
        headCells={headCells}
        listConfig={{
          page: currentPage,
          setPage: setPage,
          rowsPerPage: rowsPerPage,
          setRowsPerPage: setRowsPerPage,
          rowsPerPageOptions,
          total: applications ? applications.count : 0,
        }}
        onSelectionChange={handleSelectionChange}
        selectedRowsProp={selectedRows}
      />
    </>
  );
};

export default ApplicationListComponent;
